"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.extractHandlersFromSlice = extractHandlersFromSlice;
exports.getRequestHandler = getRequestHandler;
exports.takeLatestRequestHandler = takeLatestRequestHandler;
exports.takeRequestHandler = takeRequestHandler;
exports.takeEveryRequestHandler = takeEveryRequestHandler;

var _effects = require("redux-saga/effects");

var _snackbar_slice = require("../slices/snackbar_slice");

var _marked = /*#__PURE__*/regeneratorRuntime.mark(enqueueError);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function extractHandlersFromSlice(slice, handlerIds) {
  var handlers = {};

  var _iterator = _createForOfIteratorHelper(handlerIds),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var handlerId = _step.value;
      handlers[handlerId] = {
        request: slice.actions["".concat(handlerId, "Request")],
        success: slice.actions["".concat(handlerId, "Success")],
        error: slice.actions["".concat(handlerId, "Error")]
      };
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return handlers;
}

function getRequestHandler(handler) {
  var options = handler.options || {};
  options.errorMessageLocation = options.errorMessageLocation || 'snackbar';
  return /*#__PURE__*/regeneratorRuntime.mark(function _callee(action) {
    var response, successParams, errorParams;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return handler.method(action);

          case 3:
            response = _context.sent;

            if (!handler.success) {
              _context.next = 8;
              break;
            }

            successParams = options.successTransformer ? options.successTransformer(response, action) : response;
            _context.next = 8;
            return (0, _effects.put)(handler.success(successParams));

          case 8:
            if (!options.successMessage) {
              _context.next = 15;
              break;
            }

            if (typeof options.successMessage === 'string') options.successMessage = {
              message: options.successMessage
            };
            options.successMessage.location = options.successMessage.location || 'snackbar';
            options.successMessage.options = _objectSpread({
              variant: 'success'
            }, options.successMessage.options);

            if (!(options.successMessage.location === 'snackbar')) {
              _context.next = 15;
              break;
            }

            _context.next = 15;
            return (0, _effects.put)((0, _snackbar_slice.enqueueNotification)({
              message: options.successMessage.message,
              options: options.successMessage.options
            }));

          case 15:
            _context.next = 32;
            break;

          case 17:
            _context.prev = 17;
            _context.t0 = _context["catch"](0);
            _context.next = 21;
            return enqueueError(_context.t0, handler, options);

          case 21:
            _context.prev = 21;

            if (!handler.error) {
              _context.next = 26;
              break;
            }

            errorParams = options.errorTransformer ? options.errorTransformer(_context.t0, action) : _context.t0;
            _context.next = 26;
            return (0, _effects.put)(handler.error(errorParams));

          case 26:
            _context.next = 32;
            break;

          case 28:
            _context.prev = 28;
            _context.t1 = _context["catch"](21);
            _context.next = 32;
            return enqueueError(_context.t1, handler, options);

          case 32:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 17], [21, 28]]);
  });
}

function enqueueError(error, handler, options) {
  var message, notification;
  return regeneratorRuntime.wrap(function enqueueError$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          console.log(error);

          if (error.errors && Array.isArray(error.errors) && error.errors.length && error.errors[0].message) {
            message = error.errors.map(function (err) {
              return err.message;
            }).join('. ');
          } else if (error.message) {
            message = error.message;
          } else {
            message = "Error at ".concat(handler.request.type);
          }

          if (!(options.errorMessageLocation === 'snackbar')) {
            _context2.next = 6;
            break;
          }

          notification = {
            message: message,
            options: {
              variant: 'error',
              dismissText: options.dismissText || 'dismiss'
            }
          };
          _context2.next = 6;
          return (0, _effects.put)((0, _snackbar_slice.enqueueNotification)(notification));

        case 6:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked);
}

function takeLatestRequestHandler(handler) {
  return (0, _effects.takeLatest)(handler.request.type, getRequestHandler(handler));
}

function takeRequestHandler(handler) {
  console.warn("Please use 'takeLatestRequestHandler' instead of 'takeRequestHandler'. Its behaviour will be changed in the future.");
  return takeLatestRequestHandler(handler);
}

function takeEveryRequestHandler(handler) {
  return (0, _effects.takeEvery)(handler.request.type, getRequestHandler(handler));
}